export function makeRowID(index: number): string {
  return `tp-table-row-${index}`;
}
